export const frequenciaOptions = [
  "1x ao dia",
  "2x ao dia",
  "3x ao dia",
  "4x ao dia",
  "6/6 horas",
  "8/8 horas",
  "12/12 horas",
  "A cada 4 horas",
  "A cada 6 horas",
  "De manhã",
  "À noite",
  "Ao deitar",
  "Quando necessário (SOS)",
  "Em jejum",
  "Após as refeições",
];

export const duracaoOptions = [
  "3 dias",
  "5 dias",
  "7 dias",
  "10 dias",
  "14 dias",
  "21 dias",
  "30 dias",
  "60 dias",
  "90 dias",
  "Uso contínuo",
  "Até acabar",
  "Conforme orientação",
];

export const viaAdministracaoOptions = [
  "Oral",
  "Sublingual",
  "Intravenosa (IV)",
  "Intramuscular (IM)",
  "Subcutânea (SC)",
  "Tópica",
  "Ocular",
  "Nasal",
  "Retal",
  "Vaginal",
  "Inalatória",
];
